import { ReactNode, useLayoutEffect } from 'react';

import { SnackbarProvider, useSnackbar } from 'notistack';

import { bindSnackbar } from '@/shared/lib/snackbar';
import { AlertType } from '@/shared/types/Alert';

import { AlertContainer } from './AlertContainer';

type NotificationsProps = {
  children: ReactNode;
};

const SnackbarBridge = () => {
  const { enqueueSnackbar } = useSnackbar();

  useLayoutEffect(() => {
    bindSnackbar(enqueueSnackbar);
  }, [enqueueSnackbar]);

  return null;
};

export const Notifications = ({ children }: NotificationsProps) => {
  return (
    <SnackbarProvider
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'top',
      }}
      Components={{
        error: AlertContainer,
        info: AlertContainer,
        success: AlertContainer,
        warning: AlertContainer,
      }}
      domRoot={document.body}
      maxSnack={2}
      variant={AlertType.Error}
    >
      <SnackbarBridge />
      {children}
    </SnackbarProvider>
  );
};
